import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  features: null,
};

const activeFeaturesSlice = createSlice({
  name: "activeFeatures",
  initialState,
  reducers: {
    setFeatures: (state, action) => {
      state.features = action.payload;
    },
  },
});

export const { setFeatures } = activeFeaturesSlice.actions;
export default activeFeaturesSlice.reducer;
